/* eslint-disable react/prop-types */
import { useState, useMemo } from "react";

import { colors, darkModeColors, strCode } from "../../../consts";

import {
  FlexContainers,
  GradientLoader,
  TextOverflowWrapper,
  WrapperContainer
} from "../../../components";
import { CellWrapper } from "../../../components/Table/styled";
import { NotificationImageContainer } from "./styled";

export const NotificationsTableColumns = [
  {
    Header: strCode.NAME_TITLE,
    accessor: "notificationName",
    Cell: ({ cell, cellWidth5, searchedText, isLoading }) => {
      const [isImageLoaded, setIsImageLoaded] = useState(false);

      const imageSrc = cell.row.original?.imageSrc;

      return (
        <CellWrapper width={`${cellWidth5}px`}>
          <WrapperContainer
            Container={FlexContainers.FlexRowStart}
            gap={16}
            width={`${cellWidth5}px`}>
            <NotificationImageContainer Container={FlexContainers.FlexRowCenter}>
              {(isLoading || !isImageLoaded) && (
                <GradientLoader width={40} height={40} animationDuration={48} borderRadius={8} />
              )}

              <img
                src={imageSrc}
                alt="notification-image"
                style={{ display: isImageLoaded && !isLoading ? "block" : "none" }}
                onLoad={() => setIsImageLoaded(true)}
              />
            </NotificationImageContainer>

            <TextOverflowWrapper
              highlightedText={searchedText}
              style={{
                fontWeight: "600",
                color: darkModeColors.RAISIN_100_WHITE
              }}>
              {isLoading ? (
                <GradientLoader width={120} height={24} animationDuration={40} />
              ) : (
                cell.value
              )}
            </TextOverflowWrapper>
          </WrapperContainer>
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.BODY,
    id: "body-text",
    Cell: ({ cell, cellWidth3, isLoading }) => {
      const englishOrFirstLocalization = useMemo(() => {
        const localizations = cell.row.original.localizations;

        return localizations
          ? localizations.find((l) => l.language === "EN") || localizations[0]
          : null;
      }, [cell.row.original]);

      return (
        <CellWrapper width={`${cellWidth3}px`}>
          <TextOverflowWrapper
            maxWidth={`${cellWidth3}px`}
            style={{ color: colors.RAISIN_70, fontSize: "14px" }}>
            {isLoading ? (
              <GradientLoader width={200} height={24} animationDuration={32} />
            ) : (
              englishOrFirstLocalization?.bodyText
            )}
          </TextOverflowWrapper>
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.LOCALIZATION_TITLE,
    accessor: "localizations",
    Cell: ({ cell, cellWidth10, isLoading }) => {
      return (
        <CellWrapper width={`${cellWidth10}px`}>
          <WrapperContainer>
            <TextOverflowWrapper
              maxWidth={`${cellWidth10}px`}
              style={{ color: colors.RAISIN_70, fontSize: "14px" }}>
              {isLoading ? (
                <GradientLoader width={120} height={24} animationDuration={40} />
              ) : (
                cell?.value?.map((localization) => localization?.language)?.join(", ")
              )}
            </TextOverflowWrapper>
          </WrapperContainer>
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.OWNER_TITLE,
    accessor: "createdBy",
    Cell: ({ cell, cellWidth5, isLoading }) => {
      const { createdTs, sender } = cell?.value ?? {};

      return (
        <CellWrapper width={`${cellWidth5}px`}>
          <WrapperContainer
            width={`${cellWidth5}px`}
            Container={FlexContainers.FlexColumn}
            gap={4}
            alignItems="start">
            <TextOverflowWrapper maxWidth={`${cellWidth5}px`} style={{ color: colors.RAISIN_70 }}>
              {isLoading ? (
                <GradientLoader width={120} height={24} animationDuration={40} />
              ) : (
                sender
              )}
            </TextOverflowWrapper>

            <TextOverflowWrapper
              maxWidth={`${cellWidth5}px`}
              style={{ color: colors.RAISIN_70, fontSize: "14px" }}>
              {isLoading ? (
                <GradientLoader width={120} height={24} animationDuration={40} />
              ) : (
                createdTs
              )}
            </TextOverflowWrapper>
          </WrapperContainer>
        </CellWrapper>
      );
    }
  }
];
